module.exports = __webpack_public_path__ + "img/24.ee81052d.jpg";